// extracted by mini-css-extract-plugin
export default {"header":"Header_header__D3uey","title":"Header_title__Oc4kx"};